import { type ReactElement, type ReactNode } from "react";
import type { LinksFunction } from "react-router";

import styles from "./StickyCard.css?url";
export const StickyCardLinks: LinksFunction = () => [
  { rel: "stylesheet", href: styles },
];

type Props = Readonly<{
  children: ReactNode;
}>;

export default function StickyCard({ children }: Props): ReactElement {
  return (
    <div className="stickyCard">
      <div className="stickyItem">{children}</div>
    </div>
  );
}
